module.exports = __webpack_public_path__ + "img/badge_gray_cap-exploration.8f5b7e05.svg";